import {PureElementRule} from "../../slate/html/Html";
import {DeserializedElementRule} from "../../slate/Transformation";

export const Rules: {[key: string]: DeserializedElementRule<HTMLElement>} = {
    "a": PureElementRule('a', {tagType: 'inline', attributes: true}),
}